export default __webpack_public_path__ + "static/media/js.38d5213c.svg";